import React from 'react';

export enum TemplateStatus {
  READY_TO_USE = 'READY_TO_USE',
  NEEDS_REVIEW = 'NEEDS_REVIEW',
}

interface TemplateStatusBadgeProps {
  status: TemplateStatus;
}

const getStatusLabel = (status: TemplateStatus): string => {
  switch (status) {
    case TemplateStatus.READY_TO_USE:
      return 'Ready to use';
    case TemplateStatus.NEEDS_REVIEW:
      return 'Needs review';
    default:
      return 'Unknown';
  }
};

const getStatusColor = (status: TemplateStatus): string => {
  switch (status) {
    case TemplateStatus.NEEDS_REVIEW:
      return 'bg-yellow-50 text-yellow-700';
    case TemplateStatus.READY_TO_USE:
      return 'bg-green-50 text-green-700';
    default:
      return 'bg-gray-100 text-gray-500';
  }
};

// The shape every status badge in the templates table shares; only the colours differ.
export const BADGE_CLASSES =
  'inline-block px-2 py-1 rounded-3xl text-xs font-semibold whitespace-nowrap';

export const TemplateStatusBadge: React.FC<TemplateStatusBadgeProps> = ({
  status,
}) => {
  return (
    <span
      className={`${BADGE_CLASSES} ${getStatusColor(status)}`}
      data-testid="template-status-badge"
    >
      {getStatusLabel(status)}
    </span>
  );
};

export default TemplateStatusBadge;
